(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(91034);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37946);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  display: inline-block;\n  text-decoration: none;\n  text-align: center;\n  background: ",
        "!important;\n  padding: 1.5rem;\n  color: ",
        "!important;\n  text-transform: uppercase;\n  font-size: 1.2rem;\n  font-weight: bold;\n  border-radius: 4px!important;\n  transition: transform 0.3s;\n  backface-visibility: hidden;\n  will-change: transform;\n  cursor: pointer;\n  border: ",
        "!important;\n  opacity: ",
        ";\n  span {\n    margin-left: 1.5rem;\n  }\n\n  &:hover {\n    transform: scale(1.025);\n  }\n\n  :disabled {\n    background-color: #bbb;\n    color: #fff;\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Button = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-775d42b7-0"
})(_templateObject(), function(props) {
    return props.transparent ? "transparent" : "#174F68";
}, function(props) {
    return props.transparent ? "#174F68" : "#fff";
}, function(props) {
    return props.transparent ? "solid 1px #174F68" : "none";
}, function(props) {
    return props.isLoading ? "0.5" : "1";
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 78558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ ReCAPTCHA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50259);


function ReCAPTCHA(param) {
    var onVerify = param.onVerify, _showNotice = param.showNotice, showNotice = _showNotice === void 0 ? true : _showNotice, _refreshReCaptcha = param.refreshReCaptcha, refreshReCaptcha = _refreshReCaptcha === void 0 ? false : _refreshReCaptcha;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showNotice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                children: [
                    "Este site \xe9 protegido pelo reCAPTCHA e o Google. Consulte as",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://policies.google.com/privacy",
                        children: "Pol\xedticas de privacidade"
                    }),
                    " e os",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://policies.google.com/terms",
                        children: "Termos de Uso"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_1__/* .GoogleReCaptcha */ .mP, {
                onVerify: onVerify,
                refreshReCaptcha: refreshReCaptcha
            })
        ]
    });
}


/***/ }),

/***/ 91034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContactPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(37946);
// EXTERNAL MODULE: ./components/Page.tsx + 6 modules
var Page = __webpack_require__(97059);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(13274);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./components/ReCAPTCHA.tsx
var ReCAPTCHA = __webpack_require__(78558);
// EXTERNAL MODULE: ./contexts/ReCAPTCHAContext.tsx
var ReCAPTCHAContext = __webpack_require__(84114);
;// CONCATENATED MODULE: ./components/MailSentState.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n\n  & > *:not(:first-child) {\n    margin-top: 5rem;\n  }\n\n  svg {\n    width: 100%;\n    height: 25rem;\n  }\n\n  p {\n    font-size: 2.5rem;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function MailSentState() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                id: "b76bd6b3-ad77-41ff-b778-1d1d054fe577",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 570 511.67482",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M879.99927,389.83741a.99678.99678,0,0,1-.5708-.1792L602.86963,197.05469a5.01548,5.01548,0,0,0-5.72852.00977L322.57434,389.65626a1.00019,1.00019,0,0,1-1.14868-1.6377l274.567-192.5918a7.02216,7.02216,0,0,1,8.02-.01318l276.55883,192.603a1.00019,1.00019,0,0,1-.57226,1.8208Z",
                        transform: "translate(-315 -194.16259)",
                        fill: "#3f3d56"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                        points: "23.264 202.502 285.276 8.319 549.276 216.319 298.776 364.819 162.776 333.819 23.264 202.502",
                        fill: "#e6e6e6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M489.25553,650.70367H359.81522a6.04737,6.04737,0,1,1,0-12.09473H489.25553a6.04737,6.04737,0,1,1,0,12.09473Z",
                        transform: "translate(-315 -194.16259)",
                        fill: "#1673ff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M406.25553,624.70367H359.81522a6.04737,6.04737,0,1,1,0-12.09473h46.44031a6.04737,6.04737,0,1,1,0,12.09473Z",
                        transform: "translate(-315 -194.16259)",
                        fill: "#1673ff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M603.96016,504.82207a7.56366,7.56366,0,0,1-2.86914-.562L439.5002,437.21123v-209.874a7.00817,7.00817,0,0,1,7-7h310a7.00818,7.00818,0,0,1,7,7v210.0205l-.30371.12989L606.91622,504.22734A7.61624,7.61624,0,0,1,603.96016,504.82207Z",
                        transform: "translate(-315 -194.16259)",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M603.96016,505.32158a8.07177,8.07177,0,0,1-3.05957-.59863L439.0002,437.54521v-210.208a7.50851,7.50851,0,0,1,7.5-7.5h310a7.50851,7.50851,0,0,1,7.5,7.5V437.68779l-156.8877,66.999A8.10957,8.10957,0,0,1,603.96016,505.32158Zm-162.96-69.1123,160.66309,66.66455a6.1182,6.1182,0,0,0,4.668-.02784l155.669-66.47851V227.33721a5.50653,5.50653,0,0,0-5.5-5.5h-310a5.50653,5.50653,0,0,0-5.5,5.5Z",
                        transform: "translate(-315 -194.16259)",
                        fill: "#3f3d56"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M878,387.83741h-.2002L763,436.85743l-157.06982,67.07a5.06614,5.06614,0,0,1-3.88038.02L440,436.71741l-117.62012-48.8-.17968-.08H322a7.00778,7.00778,0,0,0-7,7v304a7.00779,7.00779,0,0,0,7,7H878a7.00779,7.00779,0,0,0,7-7v-304A7.00778,7.00778,0,0,0,878,387.83741Zm5,311a5.002,5.002,0,0,1-5,5H322a5.002,5.002,0,0,1-5-5v-304a5.01106,5.01106,0,0,1,4.81006-5L440,438.87739l161.28027,66.92a7.12081,7.12081,0,0,0,5.43994-.03L763,439.02741l115.2002-49.19a5.01621,5.01621,0,0,1,4.7998,5Z",
                        transform: "translate(-315 -194.16259)",
                        fill: "#3f3d56"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M602.345,445.30958a27.49862,27.49862,0,0,1-16.5459-5.4961l-.2959-.22217-62.311-47.70752a27.68337,27.68337,0,1,1,33.67407-43.94921l40.36035,30.94775,95.37793-124.38672a27.68235,27.68235,0,0,1,38.81323-5.12353l-.593.80517.6084-.79346a27.71447,27.71447,0,0,1,5.12353,38.81348L624.36938,434.50586A27.69447,27.69447,0,0,1,602.345,445.30958Z",
                        transform: "translate(-315 -194.16259)",
                        fill: "#1673ff"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Sua mensagem foi enviada!"
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a110dbd-0"
})(_templateObject());

// EXTERNAL MODULE: ./services/apiClient.ts
var apiClient = __webpack_require__(81372);
;// CONCATENATED MODULE: ./views/ContactPage/FormSection.tsx




function FormSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: calc(99vh - (490px));\n  background:#FBF9ED;\n\n  @media (min-width: 970px) {\n    width: 60%;\n  }\n"
    ]);
    FormSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 2;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > * {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid rgb(var(--inputBackground));\n  background: rgb(var(--inputBackground));\n  border-radius: 0.6rem;\n  font-size: 1.6rem;\n  padding: 1.8rem;\n  box-shadow: var(--shadow-md);\n\n  &:focus {\n    outline: none;\n    box-shadow: var(--shadow-lg);\n  }\n\n  @media (max-width: 478px) {\n    width: 90vw !important;\n  }\n\n  @media (max-width: 768px) {\n    width: 95vw;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  & > *:first-child {\n    margin-right: 2rem;\n  }\n\n  & > * {\n    flex: 1;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    & > *:first-child {\n      margin-right: 0rem;\n      margin-bottom: 2rem;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n\n  & > *:not(:first-child) {\n    margin-top: 0.5rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: rgb(var(--errorColor));\n  font-size: 1.5rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid rgb(var(--inputBackground));\n  background: rgb(var(--inputBackground));\n  border-radius: 0.6rem;\n  font-size: 1.6rem;\n  padding: 1.8rem;\n  box-shadow: var(--shadow-md);\n\n  &:focus {\n    outline: none;\n    box-shadow: var(--shadow-lg);\n  }\n  \n  min-height: 20rem;\n\n  /* ",
        " {\n    width: 95vw;\n  } */\n\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










function FormSection() {
    var ref = (0,react.useState)(false), hasSuccessfullySentMail = ref[0], setHasSuccessfullySentMail = ref[1];
    var ref1 = (0,react.useState)(false), hasErrored = ref1[0], setHasErrored = ref1[1];
    var ref2 = (0,index_esm/* useForm */.cI)(), register = ref2.register, handleSubmit = ref2.handleSubmit, formState = ref2.formState;
    var isSubmitSuccessful = formState.isSubmitSuccessful, isSubmitting = formState.isSubmitting, isSubmitted = formState.isSubmitted, errors = formState.errors;
    var ref3 = (0,ReCAPTCHAContext/* useReCAPTCHA */.V)(), handleVerifyRecaptcha = ref3.handleVerifyRecaptcha, recaptcha = ref3.recaptcha, refreshRecaptcha = ref3.refreshRecaptcha, setRefreshRecaptcha = ref3.setRefreshRecaptcha;
    function onSubmit(_) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(function(param) {
            var name, email, description, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = param.name, email = param.email, description = param.description;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            apiClient/* api.post */.h.post("/mail", {
                                name: name,
                                email: email,
                                subject: "Mensagem de formul\xe1rio",
                                message: description,
                                recaptcha: recaptcha
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setHasErrored(true);
                        return [
                            2
                        ];
                    case 4:
                        setRefreshRecaptcha(Date.now());
                        return [
                            7
                        ];
                    case 5:
                        setHasSuccessfullySentMail(true);
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    var isSent = isSubmitSuccessful && isSubmitted;
    var isDisabled = isSubmitting || isSent;
    var isSubmitDisabled = Object.keys(errors).length > 0 || isDisabled;
    if (hasSuccessfullySentMail) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MailSentState, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSection_Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    hasErrored && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                        children: "Couldn't send email. Please try again."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputStack, {
                                children: [
                                    errors.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                                        children: "Name is required"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                                        placeholder: "Seu nome",
                                        id: "name",
                                        disabled: isDisabled
                                    }, register("name", {
                                        required: true
                                    })))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputStack, {
                                children: [
                                    errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                                        children: "Email is required"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                                        placeholder: "Seu Email",
                                        id: "email",
                                        disabled: isDisabled
                                    }, register("email", {
                                        required: true
                                    })))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputStack, {
                        children: [
                            errors.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                                children: "Description is required"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, (0,_object_spread/* default */.Z)({
                                as: "textarea",
                                placeholder: "Digite aqui sua mensagem...",
                                id: "description",
                                disabled: isDisabled
                            }, register("description", {
                                required: true
                            })))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCAPTCHA/* ReCAPTCHA */.b, {
                            onVerify: handleVerifyRecaptcha,
                            refreshReCaptcha: refreshRecaptcha
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        as: "button",
                        type: "submit",
                        disabled: isSubmitDisabled,
                        children: "Mandar mensagem"
                    }),
                    " "
                ]
            })
        })
    });
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1ae58c0-0"
})(FormSection_templateObject());
var FormSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1ae58c0-1"
})(_templateObject1());
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-a1ae58c0-2"
})(_templateObject2());
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-a1ae58c0-3"
})(_templateObject3());
var InputGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1ae58c0-4"
})(_templateObject4(), (0,media/* media */.B)("<=tablet"));
var InputStack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1ae58c0-5"
})(_templateObject5());
var ErrorMessage = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a1ae58c0-6"
})(_templateObject6());
var Textarea = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-a1ae58c0-7"
})(_templateObject7(), (0,media/* media */.B)("=tablet"));

;// CONCATENATED MODULE: ./views/ContactPage/InformationSection.tsx

function InformationSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  margin-right: 3rem;\n  margin-bottom: 3rem;\n  background: #FBF9ED;\n \n  h3 {\n    font-family: 'P22 Mackinac Pro';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 4rem;\n    line-height: 120%;\n\n    color: #174F68;\n    margin-bottom: 2rem;\n  }\n\n  p {\n    font-weight: normal;\n    font-size: 1.6rem;\n    color: #222222, 0.7;\n  }\n\n  span {\n    opacity: 1;\n    color: rgba(var(--text), 1);\n  }\n"
    ]);
    InformationSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function InformationSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationSection_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Contato"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Email:"
                    }),
                    " contato@nossavaquinha.com.br"
                ]
            })
        ]
    });
}
var InformationSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1353ae0-0"
})(InformationSection_templateObject());

;// CONCATENATED MODULE: ./pages/contact.tsx

function contact_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background: #FBF9ED;\n\n  ",
        " {\n    flex-direction: column;\n  }\n\n  margin-top: 10rem;\n"
    ]);
    contact_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function ContactPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCAPTCHAContext/* ReCAPTCHAProvider */.g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
            isPublicPage: true,
            navbar: true,
            title: "Contato",
            description: "Entre em contato com o Nossa vaquinha!",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSection, {})
                ]
            })
        })
    });
}
var ContactContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-220e7639-0"
})(contact_templateObject(), (0,media/* media */.B)("<=tablet"));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,9866,1228,8907,4702,6804,7536,7059,9774,2888,179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);